const giftBannerExcludedPages = new Map([
    ['/newyear-tours', (pathname) => pathname === '/newyear-tours'],
    ['/ski', (pathname) => pathname === '/ski'],
    ['/weekend-tours/russia', (pathname) => pathname === '/weekend-tours/russia'],
    ['/railways/search', (pathname) => pathname === '/railways/search'],
    ['/earlybooking', (pathname) => pathname === '/earlybooking'],
    ['/kids', (pathname) => pathname.startsWith('/kids/')],
    ['/russia', (pathname) => pathname.startsWith('/russia') && pathname !== '/russia'],
    ['/tury', (pathname) => pathname.startsWith('/tury')],
]);

function shouldHideGiftCertificatesBanner() {
    const pathname = window.location.pathname;

    for (const [key, checkFn] of giftBannerExcludedPages) {
        if (checkFn(pathname) || pathname.includes(key)) {
            return true;
        }
    }

    return false;
}

export default shouldHideGiftCertificatesBanner;

